module.exports = __webpack_public_path__ + "static/media/28DGC7.4c437571.jpg";